<div class="cashback-toast">
  <div class="row">
    <div class="icon-wrap">
      <img *ngIf="icon && !iconError" class="icon" [src]="icon" alt="" (error)="iconError = true" />
    </div>

    <div class="content">
      <h3 class="title">{{ title }}</h3>
      <p class="body">{{ body }}</p>
      <button class="more-info" type="button" (click)="moreInfo()">{{ ctaText }}</button>
    </div>

    <app-close-dialog-button class="close-icon" [customClass]="'small'" [position]="true"
      (closeEvent)="close()"></app-close-dialog-button>
  </div>
</div>
